import React, { useState } from 'react';
import { Tabs, Alert } from 'antd';
import DeferredRevenueList from './DeferredRevenueList';
import DeferredRevenueForm from './DeferredRevenueForm';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean; error: any }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error('DeferredRevenue Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '24px' }}>
          <Alert
            message="Component Error"
            description={`Failed to load component: ${this.state.error?.message || 'Unknown error'}`}
            type="error"
            showIcon
          />
        </div>
      );
    }
    return this.props.children;
  }
}

const DeferredRevenueManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('list');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = () => {
    setRefreshKey(prev => prev + 1);
    setActiveTab('list');
  };

  const tabItems = [
    {
      key: 'list',
      label: 'Deferred Revenues',
      children: (
        <ErrorBoundary>
          <DeferredRevenueList key={refreshKey} />
        </ErrorBoundary>
      )
    },
    {
      key: 'create',
      label: 'Create New',
      children: (
        <ErrorBoundary>
          <DeferredRevenueForm onSuccess={handleCreated} onCancel={() => setActiveTab('list')} />
        </ErrorBoundary>
      )
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ marginBottom: '24px' }}>Deferred Revenue Management</h1>
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
    </div>
  );
};

export default DeferredRevenueManagement;
